import axios from '@/request';
import qs from 'qs';

export default {
  async list(params: any) {
    return axios.get('clubs/list', { params });
  },
  async detail(params: any) {
    return axios.get('clubs/detail', { params });
  },
  async edit(params: any) {
    return axios.post('clubs/edit', qs.stringify(params));
  },
  async delete(params: any) {
    return axios.post('clubs/delete', qs.stringify(params));
  },
  async members(params: any) {
    return axios.get('club/members/list', { params });
  },
  async activity_bulletins(params: any) {
    return axios.get('club/activity_bulletins/list', { params });
  },
  async activities(params: any) {
    return axios.get('club/activities/list', { params });
  }
};
